import CustomCheckBox from '../../../components/form/CustomCheckBox'

const FocusItemsFormMenu = ({ show = true, focusItem, setFocusItem, disabled = false }) => {

  return (
    <>
      {
        !!show &&
        <div className="flex space-x-1 items-center text-sm p-2 justify-between">
          <div className='text-base font-semibold'>Items</div>
          <ImageTitleDisplayToggle focusItem={focusItem} setFocusItem={setFocusItem} disabled={disabled} />
        </div>
      }
    </>
  )

}

export default FocusItemsFormMenu


const ImageTitleDisplayToggle = ({ focusItem, setFocusItem, label, disabled = false }) => {


  return (
    <CustomCheckBox textSize="text-sm" disabled={disabled} checked={focusItem.extras?.use_image_titles}
                    onChange={(e) => !disabled && setFocusItem({
                      ...focusItem,
                      extras: { ...focusItem.extras, use_image_titles: e.target.checked },
                    })} label={label ?? 'Add Image Titles'} />
  )
}